import executeQuery from "../lib/db.js"

export async function getList() {
	const rows = await executeQuery({
		query: `
			SELECT
				*
			FROM
				meals
			ORDER BY
				sortOrder
		`,
	})

	return rows
}
